
import Vue from "vue";
import {AuthService, DossierService, TicketService} from "@/services";
export default Vue.extend({
	data() {
		return {
			dossierConfig: AuthService.wfDossier,
			companyName: "",
			vatNumber: "",
			check: false,
			sendAndReceive: 1,
		};
	},
	computed: {
		isFormValid():boolean{
			if(this.companyName == "" || this.vatNumber == "" || this.dossierConfig.peppolRegistrationStatus==1)
				return false;
			return true;
		},
		peppolMsg(): string {
			return this.$ct(this.dossierConfig.peppolRegistrationStatus == 0 ? "peppol-msg-1" : "peppol-msg-2").toString();
		},
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async confirm(){
			let s = "Nieuwe aanvraag tot PEPPOL registratie";
			let c = "Nieuwe aanvraag tot PEPPOL registratie\nFirmanaam: " + this.companyName;
			c = c + "\nBTW nummer: " + this.vatNumber;
			c = c + (this.sendAndReceive == 1 ? "\nIk wil graag VERZENDEN EN ONTVANGEN" : "\nIk wil graag ENKEL VERZENDEN");
			await TicketService.newTicket(s, c, [], "1", "1");

			let id =  AuthService.wfDossier.id;
			await DossierService.activatePeppol(id);
			this.dossierConfig.peppolRegistrationStatus = 1;
			this.$emit("update");
		}
	},
	created(){
		this.vatNumber = this.dossierConfig.vatNumber;
	},
	i18nEx: {
		componentPrefix: "components.winbox"
	}
});
